import { API } from '@/plugins/api'
import { hamiVuex } from '@/store/base'
import Vue from 'vue'
import { projectStore } from './project'
import _ from 'lodash'

export const paywallStore = hamiVuex.store({
  $name: 'paywall',
  $state: {
    paywallMap: {},
  },
  get list() {
    return _.sortBy(Object.values(this.paywallMap), ['dt_created'])
  },
  get(id) {
    return this.paywallMap[id]
  },
  UPSERT(item) {
    this.$patch(state => {
      Vue.set(state.paywallMap, item.id, item)
    })
  },
  doLoad: _.once(async function doLoad() {
    const payload = {
      project_id: projectStore.currentId,
    }
    let result = await API.call('merchant/paywall.query', payload)
    this.$patch(state => {
      const paywallMap = {}
      result.item_s.forEach(item => {
        paywallMap[item.id] = item
      })
      state.paywallMap = paywallMap
    })
  }),
  async doCreate(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/paywall.create', payload)
    this.UPSERT(result)
    return result
  },
  async doUpdate(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/paywall.update', payload)
    this.UPSERT(result)
  },
  async doDelete(id) {
    const payload = {
      id: id,
      project_id: projectStore.currentId,
    }
    await API.call('merchant/paywall.delete', payload)
    this.$patch(state => {
      Vue.delete(state.paywallMap, id)
    })
  },
})
